export default __webpack_public_path__ + "static/media/13.7df7c076.png";